exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overlay {\n  display: flex;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 999;\n  align-items: center;\n  justify-content: center; }\n  .overlay:hover .overlay-play {\n    opacity: 1;\n    background: #000; }\n  .overlay:hover i {\n    font-size: 65px; }\n  .overlay img {\n    position: absolute;\n    top: 0;\n    max-width: 100%; }\n  .overlay-play {\n    z-index: 1;\n    border-radius: 50%;\n    opacity: 0.8;\n    color: #fff;\n    cursor: pointer; }\n  .overlay i {\n    transition: font-size 0.2s;\n    font-size: 60px; }\n", ""]);

// exports
